var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-5 py-5 border-top text-center"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-12"},[_c('bar-chart',{attrs:{"chart-data":_vm.datacollection}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }